import { Document } from '@contentful/rich-text-types'

import ContentfulColor from './ContentfulColor'
import ContentfulCustomSection from './ContentfulCustomSection'
import ContentfulImage from './ContentfulImage'

// TODO: Remove anything other than contentful_id from here. We should no longer use Contentful Product now and instead use API.
export default interface ContentfulProduct {
  readonly contentful_id: string
  readonly productImages: ContentfulProductImages[]
  readonly discount: ContentfulProductDiscount | undefined
  readonly colors: ContentfulColor[]
  readonly desktopSections: ContentfulCustomSection[] | null
  readonly mobileSections: ContentfulCustomSection[] | null
  readonly recommendedProducts: ContentfulRecommendedProducts | undefined
  readonly seoTitle?: string
  readonly seoDescription?: string
  readonly seoPrice?: number
  readonly desktopLayoutType?: PDP_LAYOUT_TYPE
  readonly mobileLayoutType?: PDP_LAYOUT_TYPE
  // readonly sizeChart: ContentfulSizeChart | undefined;
}

export enum PDP_LAYOUT_TYPE {
  DEFAULT = 'Default',
  LONG_FORM = 'Long Form',
  GIFT_CARD = 'Gift Card',
  BUNDLE = 'Bundle',
  BUNDLE_LONG_FORM = 'Bundle Long Form',
}

export interface ContentfulSizeChart {
  readonly title: string
  readonly information: string
  readonly sections: ContentfulSizeChartSection[]
  readonly measuringGuides?: string[]
}

export interface ContentfulSizeChartSection {
  readonly items: ContentfulSizeChartSectionItem[]
  readonly title: string
}

export interface ContentfulSizeChartSectionItem {
  readonly key: string
  readonly values: string
}

export interface ContentfulProductImages {
  readonly color: ContentfulColor
  readonly size: string | undefined
  readonly images: null | ContentfulImage[]
}

export interface ContentfulProductDiscount {
  readonly description: {
    raw: Document
  }
}

export interface ContentfulRecommendedProducts {
  readonly products: ContentfulRecommendedProductIdList[]
}

export interface ContentfulRecommendedProductIdList {
  readonly contentful_id: string
}
